/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, Cell, Grid, HFlow, Icon } from 'bold-ui'
import { useAcessoLotacao } from 'components/auth/useAcessoLotacao'
import { Box } from 'components/Box'
import { CboSelectField, EquipeSelectField, ProfissionalSelectField, SubmitButton } from 'components/form'
import DateRangeField from 'components/form/field/DateRangeField'
import { CiapSelectField } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { CidSelectField } from 'components/form/field/select/CidSelectField/CidSelectField'
import { MedicamentoSelectField } from 'components/form/field/select/MedicamentoSelectField'
import { SubtipoAtendimentoSelectField } from 'components/form/field/select/SubtipoAtendimentoSelectField/SubtipoAtendimentoSelectField'
import {
  tipoAtendimentoRecord,
  TipoAtendimentoSelectModel,
} from 'components/form/field/select/TipoAtendimentoSelectField/TipoAtendimentoSelectField'
import { MetaRoot } from 'util/metaPath'

import {
  HistoricoAtendimentoAdvancedFilterFormModel,
  HistoricoAtendimentoFilterFormModel,
} from '../../model/HistoricoAtendimentoModel'

export interface HistoricoAtendimentoFilterPopperProps {
  path: MetaRoot<HistoricoAtendimentoAdvancedFilterFormModel>
  advancedFilters: HistoricoAtendimentoAdvancedFilterFormModel
  tipoAtendimento: TipoAtendimentoSelectModel
  filterInitialValues: HistoricoAtendimentoFilterFormModel
  isFiltersFormClean: boolean
  close(): void
  clear(): void
  onSubmit(filters: HistoricoAtendimentoAdvancedFilterFormModel): void
}

export default function HistoricoAtendimentoFilterPopper(props: HistoricoAtendimentoFilterPopperProps) {
  const {
    path,
    advancedFilters,
    tipoAtendimento,
    filterInitialValues,
    isFiltersFormClean,
    close,
    clear,
    onSubmit,
  } = props
  const { unidadeSaude } = useAcessoLotacao()
  const isAdvancedFiltersClean = advancedFilters === filterInitialValues.filtrosAvancados

  const handleSubmit = () => {
    onSubmit(advancedFilters)
    close()
  }

  return (
    <Box
      style={css`
        width: 42rem;
        margin-top: 1rem;
      `}
    >
      <Grid gap={1} gapVertical={0.5}>
        <Cell size={6}>
          <DateRangeField
            name={path.periodo}
            label='Período'
            startPlaceholder='Data inicial'
            finalPlaceholder='Data final'
            maxDate={new Date()}
          />
        </Cell>
        <Cell size={6}>
          <SubtipoAtendimentoSelectField
            name={path.subTipoAtendimento}
            label='Subtipo do atendimento'
            idTipoAtend={tipoAtendimentoRecord[tipoAtendimento]?.id}
          />
        </Cell>
        <Cell size={6}>
          <CboSelectField name={path.cbo} label='CBO' mostrarIndisponivelLotacao={false} />
        </Cell>
        <Cell size={6}>
          <EquipeSelectField name={path.equipe} label='Equipe' unidadeSaudeId={unidadeSaude.id} />
        </Cell>
        <Cell size={6}>
          <ProfissionalSelectField name={path.profissional} label='Profissional' menuMinWidth={311} />
        </Cell>
        <Cell size={6}>
          <MedicamentoSelectField name={path.medicamento} label='Medicamento' loadItemsOnOpen={false} />
        </Cell>
        <Cell size={6}>
          <CiapSelectField name={path.ciap2} label='CIAP 2' />
        </Cell>
        <Cell
          size={6}
          style={css`
            padding-bottom: 1rem;
          `}
        >
          <CidSelectField name={path.cid10} label='CID 10' renderGrupoCiapRelacionada={false} />
        </Cell>
        <Cell size={12}>
          <HFlow hSpacing={1} justifyContent='flex-end'>
            <Button size='small' onClick={close}>
              Fechar
            </Button>
            <Button onClick={clear} disabled={isFiltersFormClean} size='small'>
              <Icon
                icon='redo'
                style={css`
                  margin-right: 0.5rem;
                `}
              />
              Limpar filtros
            </Button>
            <SubmitButton kind='primary' size='small' disabled={isAdvancedFiltersClean} handleSubmit={handleSubmit}>
              Filtrar
            </SubmitButton>
          </HFlow>
        </Cell>
      </Grid>
    </Box>
  )
}
